<template>
  <div id="app">
    <router-view />
    <transition name="el-fade-in">
      <div class="content-container-top" @click="backTop" v-show="btnFlag">
        <i class="el-icon-arrow-up"></i>
      </div>
    </transition>
  </div>
</template>
<script>
// import ScrollTop from "./components/totop";
export default {
  data() {
    return {
      btnFlag: false
    };
  },
  methods: {
    backTop() {
      /* 获取回到顶部的位置元素 .content-container-top */
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 200) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  },

  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }

  // components: {
  //   ScrollTop
  // }
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  text-decoration: none;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 1920px;
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: hidden;
  .content-container-top {
    position: fixed;
    bottom: 100px;
    right: 50px;
    width: 64px;
    height: 64px;
    background-color: #d7d7d7;
    z-index: 99;
    border-radius: 50%;
    cursor: pointer;
    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 32px;
      color: #fff;
    }
    &:hover {
      background-color: #258ffc;
    }
  }
  @media screen and (max-width: 850px) {
    .content-container-top {
      bottom: 50px;
      right: 25px;
      width: 32px;
      height: 32px;
      i{
        font-size: 16px;
      }
    }
  }
}
</style>
